module.exports = __webpack_public_path__ + "static/media/wp_8.f9e7a875.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wp_8.png
// module id = 37
// module chunks = 0